import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-contact-shipping-address-page',
  templateUrl: './account-contact-shipping-address-page.component.html',
  styleUrls: ['./account-contact-shipping-address-page.component.css']
})
export class AccountContactShippingAddressPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
